/**
 * Kabin hizmet listesindeki değişikliği KAYDETMEDEN ÖNCE özetler (2026-08-29).
 *
 * ── NEDEN VAR (saha olayı 2026-08-28) ─────────────────────────────────────
 * Bu ekrandan yapılan tek bir "Save" Atlaspark'ın hizmet listesini 3'ten 1'e
 * düşürdü. Ekranda hiçbir uyarı çıkmadı, kaydetme başarılı göründü ve kabin
 * 19 saat satış yapamadı — arıza ancak müşteri şikâyetiyle öğrenildi. Ne
 * kadar hizmetin kapanacağı kaydetmeden ÖNCE söylenseydi olay yaşanmazdı.
 *
 * 🔑 BU DOSYA OTORİTE DEĞİLDİR. Gerçek kilit sunucudadır
 * (`SocialBooth-Backend/lib/boothServiceGuard.js`): kabini hizmetsiz bırakan
 * istek 400 ile reddedilir. Buradaki kontrol yalnız NEZAKET uyarısıdır —
 * kullanıcı yanlışlıkla kapattığını kaydetmeden önce görsün diye. Bu ayrım
 * bilerek yapıldı: aynı kararı iki yerde OTORİTE olarak yazmak bu projede
 * sessiz ayrışmaya yol açtı (photoroll önizleme/baskı kadrajı). İkisi
 * ayrışırsa kullanıcı yanlış uyarı görür ama VERİ yine korunur.
 */

/** Hizmet kimliğini string'e indirger; populate edilmiş belge de gelebilir. */
function idOf(item: any): string | null {
  if (item === null || item === undefined) return null
  const raw = typeof item === 'object' && item._id !== undefined ? item._id : item
  if (raw === null || raw === undefined) return null
  const s = String(raw)
  return s && s !== '[object Object]' ? s : null
}

export interface IServiceChange {
  /** Kaydetme kabini hizmetsiz bırakır mı? (sunucu bunu reddedecek) */
  wouldEmpty: boolean
  /** Kapanacak hizmetlerin insan okunur adları — onay kutusunda gösterilir. */
  removedLabels: string[]
  /** Kapanan hizmet var mı? */
  isReduction: boolean
}

/**
 * @param before  kaydetmeden önceki hizmet listesi (kimlik ya da belge)
 * @param after   kullanıcının seçtiği liste
 * @param catalog hizmet kataloğu (`actionOptions`) — adları buradan çözülür
 */
export function summarizeServiceChange(
  before: any[],
  after: any[],
  catalog: any[]
): IServiceChange {
  const oncekiler = (Array.isArray(before) ? before : []).map(idOf).filter(Boolean) as string[]
  const sonrakiler = new Set(
    (Array.isArray(after) ? after : []).map(idOf).filter(Boolean) as string[]
  )

  const kaldirilan = oncekiler.filter((id) => !sonrakiler.has(id))

  const adlar = new Map<string, string>()
  if (Array.isArray(catalog)) {
    for (const a of catalog) {
      const id = idOf(a)
      if (id) adlar.set(id, a.label || a.name || id)
    }
  }

  return {
    // 🔑 "Sonrası boş" TEK BAŞINA yeterli değil: zaten hizmetsiz bir kabini
    // kaydetmek durumu kötüleştirmez ve kullanıcıyı boşuna durdurmamalı.
    wouldEmpty: oncekiler.length > 0 && sonrakiler.size === 0,
    // Katalogda bulunmayan kimlik YUTULMAZ: yoksa "1 hizmet kapanacak" denip
    // 2 hizmet kapanır ve kullanıcı yanlış bilgiyle onaylar.
    removedLabels: kaldirilan.map((id) => adlar.get(id) || id),
    isReduction: kaldirilan.length > 0,
  }
}
